import React, { useState } from "react";
import Navbar from "../../components/Navbar";
import Sidebar from "../Sidebar";
import axios from "axios";
import Config from "../Config";
import Cookies from "js-cookie";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { useAuthHandling } from '../useAuthhandling';

function Add() {
  let navigate = useNavigate();
  const { isAuthorized, handleUnauthorized } = useAuthHandling();

  const tokens = Cookies.get("a_token");
  if (!tokens) {
    navigate("/");
  }
  const [add, setAds] = useState({
    adTitle: "",
    link: "",
    adImage: "",
    status: true,
  });
  const [formerror, setError] = useState({});

  let name, value;

  const handleInputs = (e) => {
    console.log(e);
    name = e.target.name;
    value = e.target.value;
    setAds({ ...add, [name]: value });
  };

  const onFileChange = (e) => {
    console.log(e);
    let name = e.target.name;
    setAds({ ...add, [name]: e.target.files[0] });
  };

  const validate = (values) => {
    const errors = {};
    if (!values.adTitle) {
      errors.adTitle = "Title name is required!";
    }

    if (!values.link) {
      errors.link = "Link is required!";
    }
    if (!values.adImage) {
      errors.adImage = "Image is required!";
    } else {
      if (
        values.adImage.type === "image/jpeg" ||
        values.adImage.type === "image/jpg" ||
        values.adImage.type === "image/png"
      ) {
        if (values.adImage.size > 1024 * 1000) {
          errors.adImage =
            "maximum file size 1 mb...please upload an image less than 1 mb";
        }
      } else {
        errors.adImage = "Only support jpg, jpeg, png image!";
      }
    }

    return errors;
  };

  const PostData = async (e) => {
    e.preventDefault();
    const { adTitle, link, adImage } = add;
    const ress = validate(add);
    setError(ress);
    if (!ress.adTitle && !ress.adImage && !ress.link) {
      const formData = new FormData();
      formData.append("adTitle", add.adTitle);
      formData.append("link", add.link);
      formData.append("status", add.status);
      formData.append("adImg", add.adImage);
      axios
        .post(`${Config.apiurl}/api/v1/crm/ad/create`, formData, {
          headers: {
            Authorization: `Bearer ${Cookies.get("a_token")}`,
          },
        })
        .then((res) => {
          if (res.status === 200) {

            toast.success("Sucessfully added adds", {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            setTimeout(() => navigate("/dashboard"), 3000);

            
          } 
          else if(res.status === 401){
            handleUnauthorized();
            PostData();
          }
          else {
            toast.error("Something went wrong", {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        });
    }
  };

  return (
    <div className="container-scroller">
      <Navbar />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="row">
              <div className="col-md-12 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Advertisement</h4>
                    <p className="card-description">New Ads</p>
                    <form className="forms-sample" onSubmit={PostData}>
                      {/* <form className="forms-sample"> */}
                      <div className="form-group">
                        <label htmlFor="exampleInputUsername1">Title</label>
                        <input
                          type="text"
                          className="form-control"
                          id="exampleInputUsername1"
                          placeholder="Title"
                          name="adTitle"
                          value={add.adTitle}
                          onChange={handleInputs}
                        />
                        <label style={{ color: "red" }}>
                          {formerror.adTitle}
                        </label>
                      </div>
                      <div className="form-group">
                        <label htmlFor="exampleInputUsername1">Link</label>
                        <input
                          type="text"
                          className="form-control"
                          id="exampleInputUsername1"
                          placeholder="Link"
                          name="link"
                          value={add.link}
                          onChange={handleInputs}
                        />
                        <label style={{ color: "red" }}>{formerror.link}</label>
                      </div>
                      <div className="form-group">
                        <label htmlFor="exampleInputUsername1">Status</label>

                        <select
                          className="form-control"
                          style={{
                            color: "black",
                            backgroundColor: "#2b2e4c;",
                          }}
                          id="exampleInputUsername1"
                          name="status"
                          onChange={handleInputs}
                        >
                          <option
                            id="exampleInputUsername1"
                            name="status"
                            value="true"
                          >
                            true
                          </option>
                          <option
                            id="exampleInputUsername1"
                            name="status"
                            value="false"
                          >
                            false
                          </option>
                        </select>
                      </div>

                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Image</label>
                        <br></br>
                        <input
                          type="file"
                          name="adImage"
                          onChange={onFileChange}
                        />
                        <label style={{ color: "red" }}>
                          {formerror.adImage}
                        </label>
                      </div>
                      <button
                        type="submit"
                        onClick={PostData}
                        className="btn btn-primary me-2"
                      >
                        Submit
                      </button>
                      <ToastContainer />
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Add;
